import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, Lock } from 'lucide-react';
import { IssueVisibility } from '@momentum/types';

interface ViewGoalPrivacyProps {
  visibility: IssueVisibility;
}

export const ViewGoalPrivacy: React.FC<ViewGoalPrivacyProps> = ({
  visibility,
}) => {
  const { t } = useTranslation('goals');

  const isPublic = visibility === IssueVisibility.PUBLIC;

  return (
    <div>
      <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2 flex items-center gap-2">
        {t('privacy')}
      </label>
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-2 px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg">
          {isPublic ? (
            <Users className="h-4 w-4 text-gray-600" />
          ) : (
            <Lock className="h-4 w-4 text-gray-600" />
          )}
          <span className="text-sm font-medium text-gray-900">
            {isPublic ? t('public') : t('private')}
          </span>
        </div>
      </div>
    </div>
  );
};
